import { buildColumn, ColumnsProps, ScrollType } from '@/Helper';
import { FunctionGroupCredential, FunctionGroupCredentialData } from '@/model/DeviceAdminModel';
import { Table } from 'antd';
import React, { useEffect, useState } from 'react';
import styles from './functionGroupDeleteWarning.module.scss';

type Props = {
	data: FunctionGroupCredential[];
};

const scroll: ScrollType = { y: 272 };

const FunctionGroupDeleteWarning = (props: Props) => {
	const [dataSource, setDataSource] = useState<FunctionGroupCredentialData[]>([]);

	useEffect(() => {
		const { data } = props;
		if (data?.length > 0) {
			setDataSource(
				data.map<FunctionGroupCredentialData>(d => ({
					key: `${d.LastName}-${d.UserId}`,
					UserId: d.UserId,
					FirstName: d.FirstName,
					LastName: d.LastName,
					CredentialId: d.CredentialId,
					Action: undefined,
				}))
			);
		}
	}, []);

	const columns: ColumnsProps<FunctionGroupCredentialData>[] = [
		{
			...buildColumn(_('UserID'), 'UserId', 'auto'),
		},
		{
			...buildColumn(_('FirstName'), 'FirstName', 'auto'),
		},
		{
			...buildColumn(_('LastName'), 'LastName', 'auto'),
		},
		{
			...buildColumn(_('CredentialID'), 'CredentialId', 'auto'),
		},
	];
	return (
		<div className={styles.container}>
			<p className={styles.message}>{_('DeleteFunctionGroupWarning')}</p>
			<br />
			<Table size='small' className={styles.table} scroll={scroll} columns={columns} dataSource={dataSource} pagination={false} />
		</div>
	);
};

export { FunctionGroupDeleteWarning };
